import styled from 'styled-components'

export const MapContainer = styled.div`
  height: 500px;
  width: 100%;
`
